<template>
  <div class="p-3">
    <div class="document-history">
      <div class="document-history__title">
        <i class="fas fa-info-circle mr-2" />
        Historial de Documentos
      </div>
      <custom-result-not-found
        v-if="!isLoading && !items.length"
        class="mt-3"
        text="No hay historial disponible."
      />
      <div v-else-if="isLoading" class="document-history__empty">
        Cargando historial...
      </div>
      <div v-else class="document-history__list">
        <div
          v-for="entry in items"
          :key="entry.id"
          class="document-history__entry"
        >
          <div class="document-history__entry-body">
            <div class="document-history__entry-header">
              <div class="document-history__entry-icon">
                <i class="fas fa-retweet-alt" />
              </div>
              <div class="document-history__date">
                {{ entry.date | date }}
              </div>
              <div class="document-history__hour">
                {{ formatHistoryHour(entry.date) }}
              </div>
            </div>
            <div class="document-history__content">
              <div class="document-history__field">
                <div class="data-name">Estatus:</div>
                <custom-balloon
                  :background-color="entry.status && entry.status.color"
                  dot
                  :text="entry.status && entry.status.name"
                />
              </div>
              <div class="document-history__field">
                <div class="data-name">Nombre del Usuario:</div>
                <div class="document-history__value">
                  {{ entry.userName | empty }}
                </div>
              </div>
              <div class="document-history__field">
                <div class="data-name">Nombre del Archivo:</div>
                <div class="document-history__value">
                  {{ entry.fileName | empty }}
                </div>
              </div>
              <div v-if="entry.comment" class="document-history__comment">
                <div class="data-name">Comentario:</div>
                <div class="document-history__value">
                  {{ entry.comment }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import CustomResultNotFound from 'custom-result-not-found';
import moment from 'moment';

export default {
  name: 'DocumentsTabDocumentHistory',
  components: {
    CustomBalloon,
    CustomResultNotFound,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    formatHistoryHour(date) {
      if (!date) return '';

      return moment(date).format('hh:mm A');
    },
  },
};
</script>

<style lang="scss" scoped>
.document-history {
  background: #fff;
  padding: 20px 24px 18px;
}

.document-history__title {
  align-items: center;
  color: #111;
  display: flex;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 14px;
}

.document-history__title i {
  color: #ff6b57;
}

.document-history__empty {
  color: #727272;
  font-size: 13px;
  padding: 14px 10px;
}

.document-history__list {
  display: grid;
  gap: 10px;
  padding: 16px;
}

.document-history__entry {
  background: #f4f6f5;
  padding: 12px 16px 14px;
}

.document-history__entry-body {
  background: #f4f6f5;
}

.document-history__entry-header {
  align-items: flex-start;
  background: #fff;
  display: grid;
  grid-template-columns: 1fr auto;
  min-height: 58px;
  padding: 14px 16px;
}

.document-history__entry-icon i {
  align-items: center;
  background: #c9d4d0;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  font-size: 12px;
  height: 24px;
  justify-content: center;
  width: 24px;
}

.document-history__entry-header .document-history__date,
.document-history__entry-header .document-history__hour {
  grid-column: 2 / 3;
  text-align: right;
}

.document-history__content {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(160px, 1fr));
  padding: 12px 0 0;
}

.document-history__comment {
  grid-column: 1 / -1;
}

.document-history__date {
  color: #111;
  font-size: 12px;
  font-weight: 700;
}

.document-history__hour {
  color: #111;
  font-size: 10px;
}

.document-history__value {
  color: #111;
  font-size: 13px;
  line-height: 1.25;
}

.data-name {
  color: #727272;
  font-size: 12px;
}

@media (max-width: 991.98px) {
  .document-history__content {
    grid-template-columns: 1fr;
  }
}
</style>
